import { useState, useEffect, useRef } from 'react';
import Search from '@Services/Search';
import AppStorage from '@Services/AppStorage';

export const BOUND_OPS_CACHE_KEY = 'boundOps';

export const clearBoundOpsCache = () => AppStorage.instance.removeFromSessionStorage(BOUND_OPS_CACHE_KEY);

export default function useFetchBoundOps() {
  const [boundOps, setBoundOpsData] = useState({});
  const isMounted = useRef(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const cachedBoundOps = AppStorage.instance.getFromSessionStorage(BOUND_OPS_CACHE_KEY);

        if (cachedBoundOps && cachedBoundOps.data) {
          if (isMounted.current) {
            setBoundOpsData(cachedBoundOps);
          }
          return;
        }

        const data = await Search.getExistingBoundOperators();
        const boundOpsData = { data };

        AppStorage.instance.setToSessionStorage(BOUND_OPS_CACHE_KEY, boundOpsData);

        if (isMounted.current) {
          setBoundOpsData(boundOpsData);
        }
      } catch (error) {
        Logger.error(error);
      }
    };

    fetchData();
    return () => {
      isMounted.current = false;
    };
  }, []);
  return { boundOps };
}
